import React, { useState } from 'react';

const EmailSignup = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !email.includes('@')) {
      setMessage('Please enter a valid email address');
      setIsSuccess(false);
      return;
    }

    setIsSubmitting(true);
    setMessage('');

    try {
      // Submit to Google Form
      const formData = new FormData();
      formData.append('entry.447599979', email);
      
      await fetch('https://docs.google.com/forms/d/e/1FAIpQLSc5a-6TENPPnFXn_UpqUQNVBtoWoxIIAa19_o127C-xhDA0eQ/formResponse', {
        method: 'POST',
        body: formData,
        mode: 'no-cors' // Required for Google Forms
      });
      
      setMessage('Thanks for signing up! You\'ll hear from us soon.');
      setIsSuccess(true);
      setEmail('');
    } catch (error) {
      setMessage('Something went wrong. Please try again.');
      setIsSuccess(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="email-signup">
      <form onSubmit={handleSubmit} className="signup-form">
        <div className="signup-input-group">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email address"
            className="signup-input"
            disabled={isSubmitting}
            required
          />
          <button 
            type="submit" 
            className="signup-button"
            disabled={isSubmitting || !email}
          >
            {isSubmitting ? 'Joining...' : 'Join the List'}
          </button>
        </div>
      </form>
      
      {message && (
        <div className={`signup-message ${isSuccess ? 'success' : 'error'}`}>
          {message}
        </div>
      )}
    </div>
  );
};

export default EmailSignup;